import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from './http.service';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DataFlightService {

  private BOOKINGCLASSES: any;
  flightInsurance = [];
  SSRListActive = [];
  currentDate__ = [];

  constructor(private http: HttpService) {}

  stopList = [
    { id: 0, value: 0, isSelected: false },
    { id: 1, value: 1, isSelected: false },
    { id: 2, value: 2, isSelected: false },
    { id: 3, value: 3, isSelected: false }
  ]

  fare_type = [
    { name: 'Regular Fares', value: 0, icon_name: '', content: '', },
    { name: 'Armed Forces Fares', value: 1, icon_name: 'armed_forces.png', content: 'Mandatory for all travellers to carry a valid ARMED FORCES ID or dependent card at the time of boarding', },
    { name: 'Student Fares', value: 2, icon_name: 'student.png', content: 'Mandatory for all student to carry a valid STUDENT ID card at the time of boarding', },
    { name: 'Senior Citizen Fares', value: 3, icon_name: 'senior_citizen.png', content: 'Senior Citizen Fares age above 60+ years', },
    { name: 'Doctors & Nurses Fares', value: 4, icon_name: 'doctors_nurses.png', content: 'Applicable only for medical personnel. It is mandatory to show a valid ID at the airport, without which boarding may be denied.', },
  ]

  errFlight = [
    { id: 0, subject: 'No seat available on this flight. Please search again.', image: 'noSeat.svg' },
    { id: 1, subject: 'Booking Not Found.', image: 'noSeat.svg'},
    { id: 2, subject: 'Failed', image: 'noSeat.svg' }
  ]

  // banking_logo = [
  //   { id: 2, name: 'All', code: '-1', logo: '../../assets/main/bank_logo/dummy.png', promoword: '', index: 99},
  //   { id: 1, name: 'AXIS Bank', logo: '../../assets/main/bank_logo/AXIB.png' },
  //   { id: 2, name: 'Bank of Maharashtra', logo: '../../assets/main/bank_logo/BOMB.png' },
  //   { id: 3, name: 'Central Bank of India', logo: '../../assets/main/bank_logo/cboi.png' },
  //   { id: 4, name: 'HDFC Bank', logo: '../../assets/main/bank_logo/hdfc.png' },
  //   { id: 6, name: 'ICICI Netbanking', logo: '../../assets/main/bank_logo/icici.png' },
  //   { id: 7, name: 'IDBI Bank', logo: '../../assets/main/bank_logo/idbi.png' },
  //   { id: 8, name: 'Union Bank of India', logo: '../../assets/main/bank_logo/union.png' },
  //   { id: 9, name: 'State Bank of India', logo: '../../assets/main/bank_logo/SBIB.png' },
  //   { id: 10, name: 'Jana Cash', logo: '../../assets/main/bank_logo/jana.png' },
  //   { id: 11, name: 'jioMoney', logo: '../../assets/main/bank_logo/jio_payment.png' },
  //   { id: 12, name: 'The Mobile Wallet', logo: '../../assets/main/bank_logo/wallet.png' },
  //   { id: 13, name: 'SBI Buddy', logo: '../../assets/main/bank_logo/SBIB.png' },
  //   { id: 14, name: 'Oxigen', logo: '../../assets/main/bank_logo/oxigen.png' },
  //   { id: 15, name: 'FreeCharge', logo: '../../assets/main/bank_logo/Freecharge.png' },
  //   { id: 16, name: 'MobiKwik', logo: '../../assets/main/bank_logo/mobikwik.png' },
  //   { id: 17, name: 'UCO Bank - UCOBank Rewardz', logo: '../../assets/main/bank_logo/UCO.png' },
  //   { id: 18, name: 'HDFC Bank - Diners Club International', logo: '../../assets/main/bank_logo/hdfcdiner.png' },
  //   { id: 19, name: 'IndusInd Bank - WorldMiles', logo: '../../assets/main/bank_logo/indusind.png' },
  //   { id: 20, name: 'Central Bank of India - Anmol Rewardz', logo: '../../assets/main/bank_logo/cboi.png' },
  //   { id: 21, name: 'Bank of India - BOI Star Rewardz', logo: '../../assets/main/bank_logo/BOI.png' },
  //   { id: 22, name: 'Punjab National Bank - PNB Rewardz', logo: '../../assets/main/bank_logo/PNB.png' },
  //   { id: 23, name: 'Canara Bank - Canara Rewardz', logo: '../../assets/main/bank_logo/canara.png' },
  //   { id: 24, name: 'YES BANK - YES Rewardz', logo: '../../assets/main/bank_logo/yesbank.png' },
  //   { id: 25, name: 'Karur Vysya Bank - Anmol Rewardz', logo: '../../assets/main/bank_logo/kvb.png' },
  //   { id: 26, name: 'State Bank of India - State Bank Rewardz', logo: '../../assets/main/bank_logo/SBIB.png' },
  //   { id: 27, name: 'Federal Bank - Utsav Rewards', logo: '../../assets/main/bank_logo/Federa.png' },
  //   { id: 28, name: 'HDFC Bank - HDFC Infinia', logo: '../../assets/main/bank_logo/hdfc.png' },
  // ]

  banking_logo = [
    {id: 2, name: "All", code: "-1", logo: "../../assets/main/bank_logo/dummy.png", promoword: "", index: 99},
    {id: 1, name: "AXIS Bank", logo: "../../assets/main/bank_logo/AXIB.png"},
    {id: 2, name: "Bank of Maharashtra", logo: "../../assets/main/bank_logo/BOMB.png"},
    {id: 3, name: "Central Bank of India", logo: "../../assets/main/bank_logo/cboi.png"},
    {id: 4, name: "HDFC Bank", logo: "../../assets/main/bank_logo/hdfc.png"},
    {id: 6, name: "ICICI Netbanking", logo: "../../assets/main/bank_logo/icici.png"},
    {id: 7, name: "IDBI Bank", logo: "../../assets/main/bank_logo/idbi.png"},
    {id: 8, name: "Union Bank of India", logo: "../../assets/main/bank_logo/union.png"},
    {id: 9, name: "State Bank of India", logo: "../../assets/main/bank_logo/SBIB.png"},
    {id: 10, name: "Jana Cash", logo: "../../assets/main/bank_logo/jana.png"},
    {id: 11, name: "jioMoney", code: "JIOM", logo: "../../assets/main/bank_logo/jio_payment.png"},
    {id: 12, name: "The Mobile Wallet", logo: "../../assets/main/bank_logo/wallet.png"},
    {id: 13, name: "SBI Buddy", logo: "../../assets/main/bank_logo/SBIB.png"},
    {id: 14, name: "Oxigen", code: "OXYCASH", logo: "../../assets/main/bank_logo/oxigen.png"},
    {id: 15, name: "FreeCharge", code: "FREC", logo: "../../assets/main/bank_logo/Freecharge.png"},
    {id: 16, name: "MobiKwik", code: "mobikwik", logo: "../../assets/main/bank_logo/mobikwik.png"},
    {id: 17, name: "UCO Bank - UCOBank Rewardz", logo: "../../assets/main/bank_logo/UCO.png"},
    {id: 18, name: "HDFC Bank - Diners Club International", logo: "../../assets/main/bank_logo/hdfcdiner.png"},
    {id: 19, name: "IndusInd Bank - WorldMiles", logo: "../../assets/main/bank_logo/indusind.png"},
    {id: 20, name: "Central Bank of India - Anmol Rewardz", logo: "../../assets/main/bank_logo/cboi.png"},
    {id: 21, name: "Bank of India - BOI Star Rewardz", logo: "../../assets/main/bank_logo/BOI.png"},
    {id: 22, name: "Punjab National Bank - PNB Rewardz", logo: "../../assets/main/bank_logo/PNB.png"},
    {id: 23, name: "Canara Bank - Canara Rewardz", logo: "../../assets/main/bank_logo/canara.png"},
    {id: 24, name: "YES BANK - YES Rewardz", code: "YESW", logo: "../../assets/main/bank_logo/yesbank.png"},
    {id: 25, name: "Karur Vysya Bank - Anmol Rewardz", logo: "../../assets/main/bank_logo/kvb.png"},
    {id: 26, name: "State Bank of India - State Bank Rewardz", logo: "../../assets/main/bank_logo/SBIB.png"},
    {id: 27, name: "Federal Bank - Utsav Rewards", logo: "../../assets/main/bank_logo/Federa.png"},
    {id: 28, name: "HDFC Bank - HDFC Infinia", logo: "../../assets/main/bank_logo/hdfc.png"},
    {id: 29, name: "PayTM", code: "PAYTM", logo: "", promoword: "", index: ""},
    {id: 30, name: "Airtel Money", code: "AMON", logo: "", promoword: "", index: ""},
    {id: 31, name: "Amazon Pay", code: "AMZPAY", logo: "", promoword: "", index: ""},
    {id: 32, name: "ItzCash", code: "ITZC", logo: "", promoword: "", index: ""},
    {id: 33, name: "Ola Money", code: "OLAM", logo: "", promoword: "", index: ""},
    {id: 34, name: "Yes Bank", code: "YESW", logo: "", promoword: "", index: ""},
    {id: 35, name: "Jio Money", code: "JIOM", logo: "", promoword: "", index: ""},
    {id: 36, name: "MobiKwik", code: "mobikwik", logo: "", promoword: "", index: ""},
    {id: 37, name: "Freecharge", code: "FREC", logo: "", promoword: "", index: ""},
    {id: 38, name: "HDFC PayZapp", code: "PAYZ", logo: "", promoword: "", index: ""},
    {id: 39, name: "Aditya Birla Payments Bank", code: "ABIRLA", logo: "", promoword: "", index: ""},
    {id: 40, name: "Airtel Payments Bank", code: "AIRNB", logo: "", promoword: "", index: ""},
    {id: 41, name: "AU Small Finance Bank", code: "AUSFNB", logo: "", promoword: "", index: ""},
    {id: 42, name: "AU Small Finance Corporate Net Banking", code: "AUSFCNB", logo: "", promoword: "", index: ""},
    {id: 43, name: "Axis Bank", code: "AXIB", logo: "", promoword: "", index: ""},
    {id: 44, name: "Axis Corporate Netbanking", code: "AXISCNB", logo: "", promoword: "", index: ""},
    {id: 45, name: "Bank of Bahrain & Kuwait", code: "BBKB", logo: "", promoword: "", index: ""},
    {id: 46, name: "Bank of Baroda", code: "BBRB", logo: "", promoword: "", index: ""},
    {id: 47, name: "Bank of Baroda - Corporate Banking", code: "BBCB", logo: "", promoword: "", index: ""},
    {id: 48, name: "Bank Of India", code: "BOIB", logo: "", promoword: "", index: ""},
    {id: 49, name: "Bank Of Maharashtra", code: "BOMB", logo: "", promoword: "", index: ""}
]



  extraBaggage = [
    { id: 0, name: 'Additional 3 Kgs', value: 1250, icon: '../../assets/svgIcon/3kg_baggage.svg' },
    { id: 1, name: 'Additional 5 Kgs', value: 1350, icon: '../../assets/svgIcon/3kg_baggage.svg' },
    { id: 2, name: 'Additional 8 Kgs', value: 1550, icon: '../../assets/svgIcon/10kg_baggage.svg' }
  ];

  addMeal = [
    { id: 0, name: 'Sandwitch', value: 250, icon: '../../assets/svgIcon/sandwich.svg' },
    { id: 1, name: 'Meal', value: 350, icon: '../../assets/svgIcon/meal.svg' },
    { id: 2, name: 'Meal with Beverage', value: 550, icon: '../../assets/svgIcon/meal_beverage.svg' }
  ];

  travelInsurance = [
    { id: '1', name: 'Baggage Loss', content: 'Get up to ₹ 4,500', icon: 'baggage-loss.svg' },
    { id: '2', name: 'Delayed Trip', content: 'Get up to ₹ 5,500', icon: 'delayed-trip.svg' },
    { id: '3', name: 'Emergency Hospitalization', content: 'Get up to ₹ 4,500', icon: 'emergency-hospitalization.svg' },
    { id: '4', name: 'Personal Accident', content: 'Get up to ₹ 5,00,000', icon: 'personal-accident.svg' },
    { id: '5', name: 'Trip Cancellation', content: 'Get up to ₹ 4,500', icon: 'trip-cancellation.svg' },
    { id: '6', name: 'Baggage Loss', content: 'Get up to ₹ 4,500', icon: 'baggage-loss.svg' },
    { id: '7', name: 'Trip Delay', content: 'Get up to ₹ 5,500', icon: 'delayed-trip.svg' },
    { id: '8', name: 'Emergency Hospitalization', content: 'Get up to ₹ 4,500', icon: 'emergency-hospitalization.svg' },
    { id: '9', name: 'Personal Accident', content: 'Get up to ₹ 5,00,000', icon: 'personal-accident.svg' },
    // { id: '10', name: 'Emergency Circumstances', content: 'Get up to 4,500', icon: 'refund.png' },
  ]

  flightImg = [
    { name: 'Vistra', imgPath: '../../assets/b2c/flight/banner_img/img_1.png', islogin: 0, },
    { name: 'Vistra', imgPath: '../../assets/b2c/flight/banner_img/img_2.png', islogin: 0, },
    { name: 'Vistra', imgPath: '../../assets/b2c/flight/banner_img/img_4.png', islogin: 1, },
    { name: 'Vistra', imgPath: '../../assets/b2c/flight/banner_img/img_3.png', islogin: 0, },
    { name: 'Vistra', imgPath: '../../assets/b2c/flight/banner_img/img_5.png', islogin: 1, }
  ]

  insurance_logo = [
    { name: 'Insured Person', logo: '../../assets/belairtrip_assets/svg_icon/personal-accidnet.png' },
    { name: 'Age Group', logo: '../../assets/belairtrip_assets/svg_icon/personal-accidnet.png' },
    { name: 'Min & Max Days', logo: '../../assets/belairtrip_assets/svg_icon/trip-cancellation.png' },
    { name: 'Trip Cancellation & Interruption', logo: '../../assets/belairtrip_assets/svg_icon/trip-delay.png' },
    { name: 'Personal Accident', logo: '../../assets/belairtrip_assets/svg_icon/personal-accidnet.png' },
    { name: 'Loss of Checked-In Baggage', logo: '../../assets/belairtrip_assets/svg_icon/baggage-loss.png' },
    { name: 'Missed Connection', logo: '../../assets/belairtrip_assets/svg_icon/missed-connection.png' },
    { name: 'Emergency Evacuation and Repatriation of Mortal remains', logo: '../../assets/belairtrip_assets/svg_icon/repatriation-of-remains.png' },
    { name: 'Delay of Checked-In Baggage', logo: '../../assets/belairtrip_assets/svg_icon/baggage-delay.png' },
    { name: 'Emergency hospitalization for Injury', logo: '../../assets/belairtrip_assets/svg_icon/emergency-hospitalization.png' },
    { name: 'Trip Delay', logo: '../../assets/belairtrip_assets/svg_icon/trip-delay.png' },
    { name: 'Dental Treatment', logo: '../../assets/belairtrip_assets/svg_icon/dental-treatment.png' },
    { name: 'Loss of Passport', logo: '../../assets/belairtrip_assets/svg_icon/passport.png' },
    { name: 'Medical Expense Including Transportation, Evacuation & Repatriation of Mortal Remains', logo: '../../assets/belairtrip_assets/svg_icon/emergency-hospitalization.png' },
    { name: 'Accidental Death - Common Carrier', logo: '../../assets/belairtrip_assets/svg_icon/accidental-death.png' },
    { name: 'Financial Emergency Assistance', logo: '../../assets/belairtrip_assets/svg_icon/financial-assistance.png' },

  ]

  UPI_names = [
    { name: 'okhdfcbank'},
    { name: 'oksbi'},
    { name: 'okicici'},
    { name: 'okaxis'},
    { name: 'ybl'},
    { name: 'ibl'},
    { name: 'axl'},
    { name: 'paytm'},
    { name: 'apl'},
    { name: 'icici'},
  ]

  flightTime = [
    { id: 0, name: 'morning', time: '00:00 - 12:00', imgIcon: '../../assets/b2c/flight/morning.svg', isSelected: false },
    { id: 1, name: 'after noon', time: '12:00 - 18:00', imgIcon: '../../assets/b2c/flight/afternoon.svg', isSelected: false },
    { id: 2, name: 'night', time: '18:00 - 00:00', imgIcon: '../../assets/b2c/flight/night.svg', isSelected: false },
  ]  
  
  flightTime__ = [
    { id: 0, name: 'morning', time: '00:00 - 12:00', imgIcon: '../../assets/b2c/flight/morning.svg', isSelected_: false },
    { id: 1, name: 'after noon', time: '12:00 - 18:00', imgIcon: '../../assets/b2c/flight/afternoon.svg', isSelected_: false },
    { id: 2, name: 'night', time: '18:00 - 00:00', imgIcon: '../../assets/b2c/flight/night.svg', isSelected_: false },
  ]

  SSRLIST = [
    { id: 0, name: 'meal', image: 'assets/svgIcon/meal_beverage.svg' },
    { id: 1, name: 'baggage', image: 'assets/belairtrip_assets/svg_icon/10kg_baggage.svg' },
    { id: 3, name: 'seat', image: 'assets/svgIcon/flight_class.svg' },
    { id: 4, name: 'pets', image: 'assets/svgIcon/pets.svg' },
    { id: 5, name: 'lounge', image: 'assets/svgIcon/lounge.svg' }
  ]

  getBankIcon(logo) {
    return logo ? this.banking_logo.find(i => i.name === logo)?.logo : null;
  }

  getInsuranceIcon(logo) {
    return logo ? this.insurance_logo.find(i => i.name === logo)?.logo : null;
  }

  getErrorFlight(image) {
    return image ? this.errFlight.find(i => i.subject === image)?.image : null;
  }

   // Function to get image URL based on name
  getImageUrl(name: string): string {
    const ssr = this.SSRLIST.find(ssr => ssr.name === name);
    return ssr ? ssr.image : ''; // Return image URL if found, otherwise an empty string
  }

  getBookingClasses(): Observable<any> {
    if (this.BOOKINGCLASSES) {
      return of(this.BOOKINGCLASSES);
    }
    return this.http.flightgetall(`apiV2/bookingClass`).pipe(
      map(res => {
        if(res.statusCode === 200) {
          this.BOOKINGCLASSES = res.data;
          return this.BOOKINGCLASSES;
        } else {
          throw new Error('Failed to fetch booking classes');
        }
      }), catchError(err => {
        return of([])
      })
    )
  }
}
